"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FiltersContainer = void 0;
var _components = require("@ori-ui/components");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _FilterOption = require("../FilterOption");
var _isColorOption = require("../FilterOption/utils/isColorOption");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const FiltersContainer = (param)=>{
    let { onClear, onDelete, settings, selectedItems: items, isLoading = false } = param;
    const { getTestId } = (0, _testidGenerator.default)();
    const onDeleteInternal = (0, _react.useCallback)((key, category)=>()=>{
            onDelete(key, category);
        }, [
        onDelete
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Root, {
        "data-testid": getTestId(_constants.FILTERS_CONTAINER),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.ItemsContainer, {
                children: items.map((item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_FilterOption.FilterOption, {
                        label: item.label,
                        selected: false,
                        value: item.value,
                        type: item.type,
                        LabelProps: _constants.labelProps,
                        OptionProps: _constants.optionProps,
                        hexColors: (0, _isColorOption.isColorOption)(item) ? item.hexColors : undefined,
                        onDelete: isLoading ? undefined : onDeleteInternal(item.value, item.category)
                    }, item.value))
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.ButtonContainer, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.Button, {
                    "data-testid": getTestId(_constants.FILTERS_CONTAINER_CLEAR_BUTTON),
                    variant: "outlined",
                    color: "default",
                    disabled: isLoading,
                    onClick: onClear,
                    children: settings.clearButtonTitle
                })
            })
        ]
    });
};
exports.FiltersContainer = FiltersContainer;
